import React, { useEffect, useState } from "react";
import BouncingDiv from "./BouncingDiv";
import useRandomColor from "./hooks/useRandomColor";
import { theme } from "./assets/theme";
import { videos } from "./assets/videosDB";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { IoGrid, IoMenu } from "react-icons/io5";
import YMLogo from "./assets/YMLogo";
import Nav2 from "./Nav2";
// import Footer2 from "./Footer2";
import { useMediaQuery } from "@mantine/hooks";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import Footer from "./Footer";
import interact from "interactjs";

const vidDbTemplate = {
  video: "",
  id: "",
  thumbnailTime: 0,
  title: "",
  description: (
    <>
      Description
      <br />
    </>
  ),
};

const vidArray = [
  {
    video: videos.Body,
    id: "Body",
    thumbnailTime: 12.7,
    title: "FOOT x AZMUTH - Body",
    description: (
      <>
        this took SO LONG TO MAKE. I think it's worth it tho! -footy hefner{" "}
        <br />
        Sream Body here: https://shorturl.at/gsU24
        <br />
        Follow Foot: @wassupfoot everywhere! Follow Azmuth: @az.muth Follow
        <br />
        us: @yungmen4 EVERYYYYYWHERE!!!!
        <br />
        Credits
        <br />
        Produced by Azmuth
        <br />
        Mastered by warmbedrooms
        <br />
        Film by Evatt Carrodus
        <br />
        Starring Foot & Azmuth in “Body”
        <br />
        Copyright © 2024 Foot Productions
        <br />
        Cast:
        <br />
        Indacouch
        <br />
        Victoria Alamo
        <br />
        Lauren Jasmine <br />
        Hunimoon <br />
        Haley Castro
        <br />
        Danika Maia <br />
        Rebecca Rose
        <br />
        Director: Evatt Carrodus
        <br />
        Director: Foot <br />
        Director: Azmuth
        <br />
        Assistant Director: Victoria Alamo <br />
        Studio Location Director: Kevin F.
        <br />
        Studio Location Manager: Kevin F. <br />
        Cinematographer: Evatt Carrodus <br />
        Key Grip: Us
        <br />
        Gaffer: Again… us
        <br />
        Location Scout: Foot
        <br />
        Hair & Make Up: @slayedbykaeee on IG <br />
        Intimacy Coordinator: Victoria Alamo
        <br />
        Lead Editor: Evatt Carrodus <br />
        Co Editor: Azmuth
        <br />
        Catering: Foot Productions Cafe
        <br />
      </>
    ),
  },
  {
    video: videos.Sides,
    id: "Sides",
    thumbnailTime: 67.1,
    title: "FOOT - Sides",
    description: (
      <>
        You wanted peace but ended up saying peace out forever. <br /> Stream
        sides!:<a href=" https://tr.ee/sides"> https://tr.ee/sides</a> <br />{" "}
        Follow Foot: @wassupfoot everywhere!! <br /> Follow us: @yungmen4
        EVERYWHERE!!!!!!! <br /> Produced by: @thejuujaan <br /> Mastered:
        @inda_couch <br /> Directed by: @thejuujaan & @evvatt
      </>
    ),
  },
  {
    video: videos.Mister,
    id: "Mister",
    thumbnailTime: 15.8,
    title: "FOOT - Mister",
    description: (
      <>
        I serve it here, I serve it there. The way it serve that sh*t an art.{" "}
        <br />
        Stream MISTER here!:{" "}
        <a href="https://lnk.to/MISTERoutnow">
          https://lnk.to/MISTERoutnow
        </a>{" "}
        <br />
        Follow Foot: @wassupfoot everywhere! <br /> Follow us @yungmen4
        everywhere! <br />
        Produced by: @inda_couch <br /> Featuring: @ram3thy <br /> Mastered:
        @warmbedrooms <br />
        Video by: @evvatt & @vhrispowers <br />
        Actors: <br />
        Liz <br /> Kaleb <br /> Deaver <br /> 48Lucid <br /> JuuJaan <br />
        Evatt
      </>
    ),
  },
  {
    video: videos.OutTheGates,
    id: "0ut The Gates",
    thumbnailTime: 17.8,
    title: "Yung Men - Out The Gates",
    description: (
      <>
        Out the Gates feat. 48Lucid is a single off Yung Men's 2022 album
        release, You Hear Me!?
        <br />
        <br />
        Follow us on IG: @yungmen4 Stream on spotify here:
        <br />
        <a
          className=" underline "
          href="https://open.spotify.com/album/1mjFhH1chyrU76Xtnu9xEM?si=nSaxEY6XQ1qrD3vVlMsDZQ&nd=1&dlsi=c2a8a2eeb20a4701"
        >
          https://open.spotify.com/album/1mjFhH1chyrU76Xtnu9xEM?si=nSaxEY6XQ1qrD3vVlMsDZQ&nd=1&dlsi=c2a8a2eeb20a4701
        </a>
        <br /> Dir/Edit: @evattcarrodus DP: @vhrispowers
        <br />
        1st AC: @csiefert
        <br />
        Artwork/design by @Local Offices
      </>
    ),
  },
  {
    video: videos.Molly,
    id: "Molly",
    thumbnailTime: 38.7,
    title: "Molly - Foot x Azmuth",
    description: (
      <>
        If you ever needed a dopamine spike, here's a hit of a little... 
        {/* Sream Molly here: https://soundraiser.io/link/blackthundermountain... */}
        <br />
        <br />
        Follow Foot: @wassupfoot everywhere!
        <br />
        Follow Azmuth: @az.muth
        <br />
        Follow us: @yungmen4 EVERYYYYYWHERE!!!!
        <br />
        Follow Evatt: @evvatt <br />
        <br />
        Credits
        <br />
        <br />
        Produced by Azmuth
        <br />
        Produced by Jacob Monarch
        <br />
        Created by Evatt Carrodus
        <br />
        Starring Foot & Azmuth in “Molly”
        <br />
        Copyright © 2024 Foot Productions
        <br />
        Cast:
        <br />
        Da homies
        <br />
        Director: Evatt Carrodus
        <br />
        Director: Foot <br />
        Director: Azmuth
      </>
    ),
  },
  {
    video: videos.Runningback,
    id: "Runn!ngback",
    thumbnailTime: 6.8,
    title: "Runn!ngback - Yung Men",
    description: (
      <>
        As the dark ages descend upon us, the Yung Men stand in defiance, their
        black silhouettes cutting through the waist-high golden grass of Victory
        Trails. In the wake of the arson that nearly consumed it, this video
        serves as a haunting tribute to resilience, capturing the raw spirit of
        survival and honor for a place scarred but unbroken.
        <br />
        <br />
        Follow us: @yungmen4 EVERYYYYYWHERE!!!!
        <br />
        Follow Evatt: @evvatt
        <br />
        <br />
        Credits
        <br />
        <br />
        Produced by Myles Martin
        <br />
        Created by Evatt Carrodus
        <br />
        Starring the Yung Men
        <br />
        Cast: Da homies
        <br />
        Director: Evatt Carrodus
        <br />
        Copyright © 2025 Yung Men Productions
        <br />
      </>
    ),
  },
  {
    video: videos.AfterYou,
    id: "After You",
    thumbnailTime: 6.8,
    title: "After You - Gurg",
    description: (
      <>
        After You, by Gurg
        <br />
        <br />
        prod by JuuJaan
        <br />
        <br />
        Video directed, edited and shot by JuuJaan
      </>
    ),
  },
];

export default function Videos() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const vidSize = isMobile ? 75 : 200;
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [activeVideoObj, setActiveVideoObj] = useState();
  const [open, setOpen] = useState(false);
  const [listView, setListView] = useState(false);

  useEffect(() => {
    const videoIdFromParams = searchParams.get("videoId");
    if (videoIdFromParams) {
      const videoObj = vidArray.find((video) => video.id === videoIdFromParams);
      if (videoObj) {
        setActiveVideoObj(videoObj);
      }
    }
    // console.log("Active Video: ", activeVideoObj);
  }, []);

  useEffect(() => {}, []);

  return (
    <div className="relative flex h-[100dvh] max-h-[100dvh] max-w-[100vw] flex-col overflow-hidden">
      <Nav2
        style={{ zIndex: 100 }}
        rightElement={
          activeVideoObj || listView ? (
            <IoGrid
              fill="black"
              onClick={() => {
                setListView((p) => false);
                setActiveVideoObj();
              }}
            />
          ) : (
            <IoMenu
              fill="black"
              onClick={() => {
                setListView((p) => true);
              }}
            />
          )
        }
      />

      {/* // --------------------  List View / Bouncing Boxes START -------------------- */}
      <div
        className={`relative ${listView ? "" : "hidden"} flex w-[100vw] max-w-[100vw] flex-1 flex-col gap-2 overflow-y-scroll bg-[#333] pb-[35px] pt-2`}
      >
        {vidArray.map((videoObj, index) => (
          <div
            // --------------------  List View  --------------------
            id={`video-${index}`}
            key={videoObj.id}
            className="flex gap-2 "
          >
            <div className="max-w-1/2 aspect-video w-1/2 ">
              <video
                onClick={() => {
                  setActiveVideoObj();
                  setSearchParams({
                    videoId: videoObj.id,
                  });
                  setActiveVideoObj(videoObj);
                  setListView(false);
                }}
                className="flex w-full"
                controls={false}
                preload="metadata"
                src={videoObj.video + `#t=${videoObj.thumbnailTime}`}
                type="video/mp4"
              />
            </div>
            <div className="flex w-1/2 flex-col  text-white">
              <p className="">{videoObj.title}</p>
            </div>
          </div>
        ))}
      </div>
      <div
        id="bounce-container"
        className={`relative ${listView || activeVideoObj ? "hidden" : ""} flex h-full flex-1 overflow-hidden bg-[${theme.main}] `}
      >
        {!activeVideoObj &&
          vidArray.map((videoObj, index) => (
            <BouncingDiv
              key={index}
              // size={vidSize}
              height={vidSize}
              aspectRatio={"16/9"}
              initialVelocity={0.4}
              onCLick={() => {
                setSearchParams({
                  videoId: videoObj.id,
                });
                setActiveVideoObj(videoObj);
              }}
            >
              <div
                className={`flex aspect-video items-center justify-center bg-[${videoObj}]`}
              >
                <video
                  className="flex w-full"
                  controls={false}
                  preload="metadata"
                >
                  <source
                    src={videoObj.video + `#t=${videoObj.thumbnailTime}`}
                    type="video/mp4"
                  />
                </video>
              </div>
            </BouncingDiv>
          ))}
      </div>
      {/* // --------------------  List View / Bouncing Boxes END -------------------- */}

      {activeVideoObj && !listView && (
        <div
          className={`max-md-flex-col grid h-full w-full grid-cols-[2fr_1fr] flex-col overflow-y-scroll max-md:flex bg-[${theme.main}]`}
        >
          <div className="row-span-1 box-border flex w-full flex-col gap-2 px-2 pt-2">
            {/* Player */}
            <video
              className="aspect-video w-full rounded-lg bg-[black]"
              playsInline
              src={activeVideoObj.video}
              type="video/mp4"
              controls
              autoPlay
            >
              <track></track>
            </video>

            {/* Description */}
            <div className="max-md:{flex p-[10px]} box-border flex-col rounded-[8px] bg-[orange] p-2">
              <div className="grid h-auto w-full max-w-[100vw] grid-cols-[1fr_auto] items-center justify-center">
                <p className="flex-wrap text-wrap break-words text-2xl font-[900] max-md:text-xl">
                  {activeVideoObj.title}
                </p>
                {open ? (
                  <BiChevronUp
                    onClick={() => {
                      setOpen((prev) => !prev);
                    }}
                    className="box-border cursor-pointer self-start "
                  />
                ) : (
                  <BiChevronDown
                    onClick={() => {
                      setOpen((prev) => !prev);
                    }}
                    className="box-border cursor-pointer self-start "
                  />
                )}
              </div>
              <p
                className={`${!open && "line-clamp-2 max-h-[10vw] text-ellipsis"} text-wrap break-words text-base max-md:text-sm`}
              >
                {activeVideoObj.description}
              </p>
            </div>

            {/* Comments */}
            {/* <div className="flex flex-col gap-2">
              <div className="flex h-[70px] w-full items-center justify-center rounded-lg bg-[green] p-2">
                <div className="h-1/2 w-full rounded-lg bg-[grey] "></div>
              </div>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((e, index) => (
                <div className="max-h-[300px] min-h-[100px] w-full rounded-lg bg-[red] p-2">
                  <div className="h-full w-full bg-[green]">Comment {e}</div>
                </div>
              ))}
            </div> */}
          </div>
          <div className="flex h-[100dvh] w-full flex-col gap-0.5 bg-transparent pr-2 pt-1 max-md:gap-1 max-md:p-2 ">
            {vidArray
              .filter((videoObj) => {
                return videoObj.id !== activeVideoObj?.id;
              })
              .map((videoObj, index) => (
                <div
                  key={videoObj.id}
                  onClick={() => {
                    setActiveVideoObj();
                    setSearchParams({
                      videoId: videoObj.id,
                    });
                    setActiveVideoObj(videoObj);
                  }}
                  className="flex cursor-pointer gap-2 rounded-lg hover:bg-white max-md:bg-[grey]/30 max-md:bg-blend-color-burn"
                >
                  <div className="max-w-1/2 box-border aspect-video w-1/2 p-1 ">
                    <video
                      className="flex flex-1 rounded-[4px]"
                      controls={false}
                      preload="metadata"
                      src={videoObj.video + `#t=${videoObj.thumbnailTime}`}
                      type="video/mp4"
                    />
                  </div>
                  <div className="flex w-1/2 flex-col p-1 font-[800] text-black">
                    <p className="mt-[-2.5px]">{videoObj.title}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* <Footer2 /> */}
      <Footer color={"yellow"} />
    </div>
  );
}
